const config = {
    distribution_id: 1,
}

class ContentApi {

    constructor(seamApi) {
        this.api = seamApi;
    }


    async list(
        page = 1,
        perPage = 20,
        contentTypeIds = [],
        tags = [],
        orderBy = 'published',
        orderDirection = 'asc'
    ) {
        return this.api.handleResponse(async () => {

            const response = await this.api.get('/content-list', {
                params : {
                    page,
                    per_page: perPage,
                    content_type_ids: contentTypeIds,
                    tag_ids: tags,
                    distribution_id : config?.distribution_id,
                    order_by : orderBy,
                    order_direction : orderDirection
                }
            });

            return response.data;
        });
    }

    async page(slug) {
        return this.api.handleResponse(async () => {
            const response = await this.api.get('/content-page', {
                params : {
                   path : slug,
                    distribution_id : config?.distribution_id
                }
            });
            return response.data;
        });
    }

    async contentTypeTags(contentTypeId) {
        return this.api.handleResponse(async () => {
            const response = await this.api.get(`/content-type-tags/${contentTypeId}`);
            return response.data;
        });
    }

    async search(term, contentTypeIds=  [], tags = [], cancelHandler = () => {}) {
        return this.api.handleResponse(async () => {
           const response = await this.api.post('/page-search', {
                  term : term,
                  distribution_id : config?.distribution_id,
                  filters : {
                      content_type_ids : contentTypeIds,
                      tag_ids : tags
                  },

           }, this.api.defaultValidationHandler, cancelHandler);
            return response.data;
        });

    }

}

export default ContentApi;
